import React, {useState} from 'react';
import Modal from "react-modal";
import {makeApiCall} from "../../../Api/makeApiCall";
import PropTypes from "prop-types";
import FtpConfigs from "../../Configurations/FtpConfigs";
import {ConfigType} from "../../Configurations/FileTypes";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {convertGsutilPathToBrowserGcsUrl} from "../../../utils/gcsUtils";
import {faIcons} from "../../../utils/iconConstants";

export const ShowFilePartial = ({path, ftp, fileType, maxCharacters = 2000}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileData, setFileData] = useState(undefined);
    const [loading, setLoading] = useState(true);

    async function getFilePartial() {
        setIsModalOpen(true);
        setLoading(true);
        const encodePath = encodeURIComponent(path);
        const url = `${process.env.REACT_APP_EDP_API_BASE_URL}/getGcsFilePartial/?path=${encodePath}&start=0&end=${maxCharacters}`;
        makeApiCall(url)
            .then(results => setFileData(results.apiError ? "Error retrieving file" : results))
            .finally(() => setLoading(false));
    }

    return (<>
        <div className={`clickable-thingy ${faIcons.eye} fa-2x`} data-testid={"eye_button"}
             onClick={async () => await getFilePartial(path)}/>
        <Modal
            isOpen={isModalOpen}
            className="Modal"
            overlayClassName="Overlay"
            ariaHideApp={false}
            testId={"show_file_partial_modal"}
        >
            <div className={"modal-header"} data-testid={"modal-header"}>
                <div><h5 className={"modal-header-text"}>
                    Preview File: <a target='_blank'
                       rel="noopener noreferrer"
                       href={convertGsutilPathToBrowserGcsUrl(path)}
                    >
                    {path}
                    </a>
                </h5></div>
                <div data-testid={'confirmation-modal-exit-button'}>
                    <button className={"right-exit-button"} onClick={() => setIsModalOpen(false)}>
                        <i data-testid={'x-icon'} className={faIcons.xClose} /></button>
                </div>
            </div>
            <div className={'file-partial-modal-container'}>
                <div className={'ftp-configs-container'}>
                    <FtpConfigs ftp={ftp} buttonTitle={ftp} configType={fileType} isModalMode={false}/>
                </div>
                <div className={'file-partial-content-container'}>
                    <h6>First <b>{maxCharacters}</b> characters</h6>
                    <LoadingWrapper loading={loading} spinnerClassName={'spinner-container-medium'}>
                        <div className={'file-partial-content'} data-testid={"file_partial_content"}>{fileData}</div>
                    </LoadingWrapper>
                </div>
            </div>
        </Modal>
    </>)
}

ShowFilePartial.propTypes = {
    path: PropTypes.string,
    ftp: PropTypes.string,
    fileType: PropTypes.instanceOf(ConfigType).isRequired,
    maxCharacters: PropTypes.number,
}
